import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import { CircularProgress, TableHead, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useStyles } from '../../assets/styles/listTableStyle';

import Error from '../error/error';
import { TableCellHead } from '../table/tableCell';
import UnallocationTableRowItem from './unallocationTableRowItem';
import { useParams } from 'react-router-dom';
import { unallocateAnalyseBulkVendor } from '../../redux/slices/vendorList';

interface DataInformationTableProps {
    formDataArray: any;
    selectedType?: string;
}

const VendorBulkUnallocationTable: React.FC<DataInformationTableProps> = ({ formDataArray, selectedType }) => {
    const classes = useStyles();
    const [tableSwitch, setTableSwitch] = useState("CURRENT");
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const analyseData = useSelector((state: RootState) => state.vendorList.analyse);
    const unallocateAnalyseStatus = useSelector((state: RootState) => state.vendorList.unallocateAnalyseStatus)
    const createVendorAnalyseStatus = useSelector((state: RootState) => state.vendorList.createAnalyseUnallocateStatusTaskIDs)
    const createVendorTaskIDs = useSelector((state: RootState) => state.vendorList.analyseTaskIDs)

    const isType2 = selectedType === 'Type 2';
    const isType3 = selectedType === 'Type 3';

    const status = isType2 ? unallocateAnalyseStatus : createVendorAnalyseStatus;
    const data = isType2 ? analyseData : createVendorTaskIDs;

    const headers = [
        "VENDOR NAME", 
        ...(tableSwitch !== 'ALL' ? ['STAGE NAME'] : []),
        "REMAINING TASKS AFTER THIS UNALLOCATION", 
        "TOTAL TASKS ALLOCATED TILL NOW", 
        "TOTAL ALLOCATED TASKS TO EXPERTS BY THIS VENDOR"
    ]

    const handleChangeToggle = (event: any, table: string) => {
        if (table !== null) {
            setTableSwitch(table);
            const payload = {
                project_id: id,
                data: formDataArray.map((item: any) => ({
                    vendor_id: item.vendor_id,
                    task_count: Number(item.task_count),
                    stage: Number(item.type),
                    status: item.status ? item.status.split(", ") : []
                })),
                analyse_all: table === 'ALL',
            }
            dispatch(unallocateAnalyseBulkVendor(payload))
        }
    };

    return (
        <>
            <ToggleButtonGroup
                color="standard"
                value={tableSwitch}
                exclusive
                onChange={handleChangeToggle}
            >
                <ToggleButton
                    value="CURRENT"
                    style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: tableSwitch === 'CURRENT' ? '#03BBD2' : '#6C6C6C',
                        borderBottom: tableSwitch === 'CURRENT' ? '3px solid #03BBD2' : 'none',
                        backgroundColor: 'inherit',
                        textTransform: 'none'
                    }}
                >
                    Current Project
                </ToggleButton>
                <ToggleButton
                    value="ALL"
                    style={{
                        border: 'none',
                        fontFamily: 'Montserrat',
                        fontSize: '14px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: tableSwitch === 'ALL' ? '#03BBD2' : '#6C6C6C',
                        borderBottom: tableSwitch === 'ALL' ? '3px solid #03BBD2' : 'none',
                        backgroundColor: 'inherit',
                        textTransform: 'none'
                    }}
                >
                    All Project
                </ToggleButton>
            </ToggleButtonGroup>
            <TableContainer sx={{ backgroundColor: 'white', minHeight: '200px' }}>
                {status === STATUS.PENDING && (
                    <div className={classes.progressDiv}>
                        <CircularProgress />
                    </div>
                )}
                {status === STATUS.SUCESS && (
                    <>
                        <Table className={classes.tableContainer} aria-label="simple table">
                            <TableHead>
                                {headers.map((header) => (
                                    <TableCellHead key={header}>{header}</TableCellHead>
                                ))}
                            </TableHead>
                            <TableBody>
                                {data && data.length > 0 ? (
                                    data.map((row: any) => (
                                        <>
                                            <UnallocationTableRowItem
                                                key={row.id}
                                                row={row}
                                                showStageName={tableSwitch !== 'ALL'}
                                            />
                                        </>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} className={classes.noUsersMessage}>
                                            <Error message={'There are no data added as of yet.'} />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                    </>
                )}
            </TableContainer>
        </>
    );

}

export default VendorBulkUnallocationTable;